export enum ACTIVE_INVENTORY_SECTION {
  HOME = 0,
  CATALOG = 1,
  CONTACT = 2,
}
